import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import picturesScripts from './picturesScripts';
import styles from './picturesStyles';
import Imgs from './Imgs';
import { img, staticsUrl } from '../../../config';

class Pictures extends React.Component {
  currentWordNo = 0;
  img1Refs = [];
  img2Refs = [];
  textTimeout = 0;
  okTimeout = 0;
  complete = false;
  wrongAnswers = 0;
  waiting = false;

  constructor(props) {
    super(props);
    this.canvasRef = React.createRef(null);
    this.imgWrapRef = React.createRef(null);
    this.canvasWrapRef = React.createRef(null);
    this.textRef = React.createRef(null);
    this.inputRef = React.createRef(null);
    this.precision = this.props.mobile ? 1 : 1;
    this.hoveredWord = false;

    this.state = {
      mode: 'intro',
      zoom: 1.3,
      showStart: false,
      showRestart: false,
      showNav: true,
      showHelp: false,
      showOk: false,
      showFail: false,
      pending: [],
    }
    // eslint-disable-next-line
    for (let i = 0; i < this.props.hotPoints.words.length; i++) this.img1Refs[i] = React.createRef(null);
    // eslint-disable-next-line
    for (let i = 0; i < this.props.hotPoints.words.length; i++) this.img2Refs[i] = React.createRef(null);
    const context = {
      hotPoints: this.props.hotPoints,
      mobile: props.mobile,
      canvasRef: this.canvasRef,
      imgWrapRef: this.imgWrapRef,
      canvasWrapRef: this.canvasWrapRef,
      textRef: this.textRef,
      setZoom: this.setZoom,
      img1Refs: this.img1Refs,
      img2Refs: this.img2Refs,
      play: props.play,
      precision: this.precision,
      getZoom: this.getZoom,
    };
    this.scripts = picturesScripts(context);
  }

  componentDidMount() {
    this.resetPending();
  }

  componentWillUnmount() {
    this.scripts.destruct();
    clearTimeout(this.textTimeout);
    clearTimeout(this.okTimeout);
  }

  resetPending = () => {
    const pending = [];
    this.props.hotPoints.words.forEach((_, idx) => pending.push(idx));
    pending.sort(() => Math.random() - 0.5);
    this.setState({ pending });
    return pending;
  }

  zoomIn = () => {
    this.props.action();
    let newZoom = this.state.zoom + 0.5;
    if (newZoom > 3) this.setState({ zoom: 3 });
    this.setState({ zoom: newZoom });
    this.focus();
  }

  zoomOut = () => {
    this.props.action();
    let newZoom = this.state.zoom - 0.5;
    if (newZoom < 1) this.setState({ zoom: 1 });
    this.setState({ zoom: newZoom });
    this.focus();
  }

  setZoom = (no) => {
    this.setState({ zoom: no });
    this.focus();
  }

  getZoom = () => {
    return this.state.zoom;
  }

  prev = () => {
    clearTimeout(this.textTimeout);
    this.props.action();
    this.focus();
    switch (this.mode) {
      case 'test':
        break;
      default:
        this.onPrevIntro();
    }
  }

  next = () => {
    clearTimeout(this.textTimeout);
    this.props.action();
    this.focus();
    switch (this.mode) {
      case 'test':
        break;
      default:
        this.onNextIntro();
    }
  }

  onClick = ev => {
    if (this.waiting) return;
    clearTimeout(this.textTimeout);
    this.props.action();
    this.focus();
    switch (this.state.mode) {
      case 'test':
        this.onClickTest();
        break;
      case 'free-play':
        this.onClickFreePlay();
        break;
      default:
        this.clickHandler(ev);
    }
  }

  onHover = (ev) => {
    this.props.action();
    this.scripts.mouseMove(ev);
    if (this.state.mode !== 'intro') return;
    const hovered = this.scripts.findClicked();
    if (hovered) {
      if (!this.hovered || hovered.text !== this.hovered.text) {
        this.hovered = hovered;
        this.scripts.hideAll();
        this.scripts.showImg1(hovered);
        this.scripts.showImg2(hovered);
        this.scripts.setText(hovered);
        this.scripts.play(hovered);
      }
    } else {
      if (this.hovered) {
        this.scripts.hideAll();
        this.hovered = false;
      }
      this.scripts.setText(' ');
    }
  }

  clickHandler = (ev) => {
    const word = this.scripts.findClicked();
    if (word) {
      this.scripts.hideAll();
      this.scripts.play(word);
      this.scripts.setText(word);
      this.scripts.showImg1(word);
      this.scripts.showImg2(word);
    }
  }

  onNextIntro = () => {
    if (this.currentWordNo < this.props.hotPoints.words.length - 1) {
      this.currentWordNo++;
    } else {
      this.currentWordNo = 0;
    }
    this.updateIntro();
  }

  onPrevIntro = () => {
    if (this.currentWordNo > 0) {
      this.currentWordNo--;
    } else {
      this.currentWordNo = this.props.hotPoints.words.length - 1;
    }
    this.updateIntro();
  }

  updateIntro() {
    this.scripts.stopBlinkAll();
    this.scripts.hideAllImg2();
    this.scripts.setText(this.state.showStart ? 'click start button' : 'click on flashing image');
    this.scripts.blinkWord(this.currentWordNo);
    this.scripts.showImg2(this.currentWordNo);
    this.scripts.scrollToImg(this.currentWordNo);
  }

  startTest = () => {
    this.scripts.hideAll();
    this.setState({ mode: 'test', showStart: false, showNav: false, showRestart: false });
    const pending = this.resetPending();
    const no = pending[0];
    this.scripts.stopBlinkAll();
    this.scripts.hideAllImg2();
    this.currentWordNo = 0;
    this.scripts.play(no);
    this.scripts.setText(no);
    this.scripts.showImg2(no);
  }

  onClickTest = () => {
    const pending = [...this.state.pending];
    let no = pending[0];
    if (this.scripts.isWordClicked(no)) {
      this.scripts.setText('Bravo!!!');
      this.scripts.flashWord(no);
      this.setState({ showOk: true });
      this.okTimeout = setTimeout(() => {
        this.setState({ showOk: false });
      }, 1000);
      if (pending.length > 1) {
        const wordNo = pending.shift();
        if (this.wrongAnswers > 2) {
          pending.push(wordNo);
        }
        no = pending[0];
        this.setState({ pending });
      } else {
        this.onTestFinish();
        return;
      }
    } else {
      this.scripts.setText('Try again');
    }
    this.waiting = true;
    this.textTimeout = setTimeout(() => {
      this.scripts.play(no);
      this.scripts.setText(no);
      this.scripts.stopBlinkAll();
      this.waiting = false;
      this.scripts.hideAllImg2();
      this.scripts.showImg2(no);
    }, 2000);
  }

  help = () => {
    const no = this.pending[0];
    this.scripts.scrollToImg(no);
    this.scripts.blinkWord(no);
    this.focus();
  }

  onTestFinish = () => {
    this.waiting = true;
    this.textTimeout = setTimeout(() => {
      this.props.finish();
      this.scripts.hideAllImg2();
      this.scripts.setText('Contratulations !!!');
      this.scripts.stopBlinkAll();
      this.setState({ mode: 'intro' });
      this.waiting = false;
    }, 2500);
  }

  onClickFreePlay = () => {
    this.scripts.stopBlinkAll();
    const word = this.scripts.findClicked();
    if (word) {
      this.scripts.play(word);
      this.scripts.setText(word);
      this.scripts.blinkWord(word);
      this.textTimeout = setTimeout(() => {
        this.scripts.stopBlinkAll();
      }, 1500);
    }
  }

  onKeyPress = (ev) => {
    const code = ev.keyCode;
    if (code === 39 || code === 190 || code === 32) this.next();
    if (code === 37 || code === 188 || code === 13) this.prev();
    this.inputRef.current.value = '';
  }

  focus = () => {
    if (this.props.mobile) return;
    if (this.inputRef && this.inputRef.current) this.inputRef.current.focus();
  }

  render() {
    const { classes } = this.props;
    const canvasStyle = {
      width: this.props.hotPoints.width,
      height: this.props.hotPoints.height,
      transform: 'scale(' + this.state.zoom + ')',
    };
    const canvasWrapStyle = {
      width: Math.ceil(this.props.hotPoints.width * this.state.zoom),
      height: Math.ceil(this.props.hotPoints.height * this.state.zoom),
      display: 'inline-block',
      transition: 'all 0.3s',
      verticalAlign: 'middle',
    };

    return (
      <>
        <div className={classes.textBox}>
          <div className={classes.text} ref={this.textRef}>&nbsp;</div>
        </div>

        <div className={classes.imgWrap} ref={this.imgWrapRef}>
          <i className={classes.vAlign}></i><div style={canvasWrapStyle} ref={this.canvasWrapRef}>
            <div className={classes.canvas} style={canvasStyle}>
              <img src={staticsUrl + this.props.hotPoints.url} alt="" />
              {this.props.hotPoints.words.map((word, idx) => <Imgs
                data={word}
                key={idx}
                img1Ref={this.img1Refs[idx]}
                img2Ref={this.img2Refs[idx]}
              />)}
              <div
                className={classes.board}
                onClick={this.onClick}
                onMouseMove={this.onHover}
                ref={this.canvasRef}
              />
            </div>
          </div>
        </div>

        <div className={classes.buttons}>
          {this.state.mode === 'test' && <span>{this.props.hotPoints.words.length - this.state.pending.length + 1} / {this.props.hotPoints.words.length}</span>}
          <div className={classes.action}>
            {this.state.showOk && <img src={img('ok.png')} alt='' />}
            {this.state.showFail && <img src={img('wrong.png')} alt='' />}
            {this.state.mode === 'intro' && <img src={img('next.png')} alt='' onClick={this.startTest} />}
            {this.state.mode === 'test' && <img src={img('next.png')} alt='' />}
          </div>

        </div>
      </>
    );
  }
}

export default withStyles(styles)(Pictures);